import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BasicInfoStep = ({ formData, updateFormData, errors, onNext }) => {
  const handleInputChange = (field, value) => {
    updateFormData(field, value);
  };

  const handleOAuthLogin = (provider) => {
    // Mock OAuth integration
    console.log(`OAuth login with ${provider}`);
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Let's start with the basics
        </h2>
        <p className="text-muted-foreground">
          Create your account to begin building your anonymous profile
        </p>
      </div>
      {/* OAuth Options */}
      <div className="space-y-3 mb-6">
        <Button
          variant="outline"
          fullWidth
          iconName="Chrome"
          iconPosition="left"
          onClick={() => handleOAuthLogin('google')}
        >
          Continue with Google
        </Button>
        
        <Button
          variant="outline"
          fullWidth
          iconName="Github"
          iconPosition="left"
          onClick={() => handleOAuthLogin('github')}
        >
          Continue with GitHub
        </Button>
        
        <Button
          variant="outline"
          fullWidth
          iconName="Linkedin"
          iconPosition="left"
          onClick={() => handleOAuthLogin('linkedin')}
        >
          Continue with LinkedIn
        </Button>
      </div>
      <div className="relative mb-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">
            Or continue with email
          </span>
        </div>
      </div>
      {/* Email/Password Form */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="First Name"
            type="text"
            placeholder="John"
            value={formData?.firstName}
            onChange={(e) => handleInputChange('firstName', e?.target?.value)}
            error={errors?.firstName}
            required
          />
          
          <Input
            label="Last Name"
            type="text"
            placeholder="Doe"
            value={formData?.lastName}
            onChange={(e) => handleInputChange('lastName', e?.target?.value)}
            error={errors?.lastName}
            required
          />
        </div>

        <Input
          label="Email Address"
          type="email"
          placeholder="john@example.com"
          description="We'll use this to send you important updates"
          value={formData?.email}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
          error={errors?.email}
          required
        />

        <Input
          label="Password"
          type="password"
          placeholder="Create a strong password"
          description="At least 8 characters with numbers and symbols"
          value={formData?.password}
          onChange={(e) => handleInputChange('password', e?.target?.value)}
          error={errors?.password}
          required
        />

        <Input
          label="Confirm Password"
          type="password"
          placeholder="Confirm your password"
          value={formData?.confirmPassword}
          onChange={(e) => handleInputChange('confirmPassword', e?.target?.value)}
          error={errors?.confirmPassword}
          required
        />
      </div>
      {/* Privacy Notice */}
      <div className="bg-primary/5 rounded-lg p-4 mt-6 border border-primary/20">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} className="text-primary mt-0.5" />
          <div className="text-sm">
            <div className="font-medium text-foreground mb-1">
              Your privacy is protected
            </div>
            <div className="text-muted-foreground">
              Your personal information will be anonymized when shown to employers. 
              Only you control when to reveal your identity.
            </div>
          </div>
        </div>
      </div>
      {/* Terms Agreement */}
      <div className="mt-6">
        <label className="flex items-start space-x-3 cursor-pointer">
          <input
            type="checkbox"
            checked={formData?.agreeToTerms}
            onChange={(e) => handleInputChange('agreeToTerms', e?.target?.checked)}
            className="mt-1 h-4 w-4 text-primary border-border rounded focus:ring-primary"
          />
          <span className="text-sm text-muted-foreground">
            I agree to the{' '}
            <a href="/terms" className="text-primary hover:underline">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" className="text-primary hover:underline">
              Privacy Policy
            </a>
          </span>
        </label>
        {errors?.agreeToTerms && (
          <p className="text-error text-sm mt-1">{errors?.agreeToTerms}</p>
        )}
      </div>
      <div className="flex justify-end mt-8">
        <Button
          onClick={onNext}
          iconName="ArrowRight"
          iconPosition="right"
          disabled={!formData?.agreeToTerms}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default BasicInfoStep;